'use strict';

wbApp.controller('ActionsStudentsCtrl', ['$scope', '$q', '$modal', '$window', '$translate', '$filter', 'securitySvc', 'tenantSettingSvc', 'courseRegistrationSvc', 'gridSortSvc',
function ($scope, $q, $modal, $window, $translate, $filter, securitySvc, tenantSettingSvc, courseRegistrationSvc, gridSortSvc) {

    $scope.tenantSettings = tenantSettingSvc.settings;

    $scope.selectedAction = null;
    var isActive = false;
    var loaded = false;
    $scope.canAddNewRow = false;
    $scope.actionRegistrations = [];

    function setCanAddNewRow() {
        if (loaded && !!$scope.selectedAction && !!$scope.selectedAction.firstLesson) {
            $scope.canAddNewRow = true;
        } else {
            $scope.canAddNewRow = false;
        }
    }

    $scope.$on('selectedActionChanged', function (e, actionInd) {
        if (actionInd.action) {
            if (isActive) {
                if ($scope.selectedAction !== actionInd.action || actionInd.refresh) {
                    $scope.actionRegistrations = courseRegistrationSvc.getAllForCourse(actionInd.action.courseID);
                    $scope.actionRegistrations.$promise.then(function () {
                        setUpGrid();
                        setCanAddNewRow();
                    });
                }
                loaded = true;
            } else {
                loaded = false;
            }
        } else {
            $scope.actionRegistrations.length = 0;
        }
        $scope.selectedAction = actionInd.action;
        setCanAddNewRow();
    });

    $scope.$on('activeTabChanged', function (e, data) {
        if (data.activeTab === 1) {
            if (!isActive) {
                isActive = true;
                if (!loaded && $scope.selectedAction) {
                    $scope.actionRegistrations = courseRegistrationSvc.getAllForCourse($scope.selectedAction.courseID);
                    $scope.actionRegistrations.$promise.then(function () {
                        setUpGrid();
                        setCanAddNewRow();
                    });
                    loaded = true;
                }
            }
        } else {
            isActive = false;
        }
        setCanAddNewRow();
    });

    $scope.gridSettings = {
        columns: [
            {
                dataField: 'studentFullName', caption: $translate.instant('TXT_HUMAN_NAME'), dataType: 'string', width: '190px', sortOrder: 'asc',
                calculateSortValue: function (data) { return gridSortSvc.sortHumanFullName(data, 'studentName', 'studentSurname', 'studentMiddleName') },
            },
            { dataField: 'studentAge', caption: $translate.instant('TXT_LBL_AGE'), dataType: 'string', width: '70px' },
            {
                dataField: 'contactPhone',
                caption: $translate.instant('TXT_LBL_PHONE'),
                dataType: 'string',
                calculateCellValue: function (rowData) {
                    return $filter('phone')(rowData.contactPhone);
                },
                width: '140px'
            },
            { dataField: 'contactEmail', caption: $translate.instant('TXT_LBL_EMAIL'), dataType: 'string', width: '190px' },
            { dataField: 'notes', caption: $translate.instant('TXT_NOTE'), dataType: 'string' },
            { dataField: 'attendanceStatusText', caption: $translate.instant('TXT_LBL_ATTENDANCE'), dataType: 'string', width: '100px' },
            { dataField: 'paymentsSum', caption: $translate.instant('TXT_LBL_PAYMENTS'), dataType: 'number', format: { type: 'currency', precision: 2 }, width: '100px' },
            { dataField: 'reservedPlaces', caption: $translate.instant('TXT_LAB_RESERVED_PALCES'), dataType: 'number', width: '40px' },
            { dataField: 'registrationDate', caption: $translate.instant('TXT_SEC_CLIENT_COURSE_REGISTRATION'), dataType: 'date', format: { date: 'short' }, width: '110px' },
        ],
        shouldDisableAdd: function () { return !$scope.selectedAction || !$scope.canAddNewRow },
        onRowPrepared: function (e) {
            if (e.rowType == "data") {
                var data = e.component.getKeyByRowIndex(e.rowIndex);                
                if (data.attendanceStatusNotPresent) {
                    e.rowElement.addClass('text-muted');
                }
            }
        },
        onCellPrepared: function (e) {
            if (e.rowType === "data" && e.columnIndex == 2) {
                e.cellElement.mousemove(function () {
                    if (!!e.data.studentBirthday) {
                        e.cellElement.attr('title', $translate.instant("TXT_LAB_BIRTHDAY") + ": " + $filter('date')(e.data.studentBirthday, 'shortDate'));
                    }
                });
            }
        },
        customCommands: [{
            text: $translate.instant('TXT_MENU_CREATE_PAYMENT'),
            isVisible: function (row) { return (row.arrear > 0) && securitySvc.isInRole('Payment.Insert'); },
            callback: function (row) { addPayment(row); }
        }, {
            text: $translate.instant('TXT_MENU_PRINT_INVOICE'),
            isVisible: function () { return securitySvc.isInRole('Reports'); },
            callback: function (data) { onPrintInvoice(data.courseRegistrationID); }
        }, {
            text: $translate.instant('TXT_MENU_PRINT_APPLICATION_FORM'),
            isVisible: function () { return securitySvc.isInRole('Reports') && securitySvc.isInRole('CourseRegistration.PrintApplicationForm'); },
            callback: function (data) { onPrintApplicationForm(data.courseRegistrationID); }
        }, {
            text: $translate.instant('TXT_MENU_EDIT_ATTENDANCE'),
            isVisible: function () { return securitySvc.isInRole('Attendance.Update'); },
            callback: function (data) { onAttendanceUpdate(data.courseID, data.studentID); }
        }, {
            text: $translate.instant('TXT_MENU_RESEND_COURSE_REGISTRATION_NOTIFICATION'),
            isVisible: function () { return securitySvc.isInRole('CourseRegistration'); },
            callback: function (data) {
                courseRegistrationSvc.sendRegistrationNotification(data.courseRegistrationID)
                .then(function () {
                    data.notificationSent = true;
                });
            }
        }]
    }


    function setUpGrid() {
        if ($scope.selectedAction && $scope.gridSettings.gridInstance) {
            $scope.gridSettings.gridInstance.columnOption('reservedPlaces', 'visible', $scope.selectedAction.allowMultiAttendance);
        }
    }

    function onPrintInvoice(courseRegistrationID) {
        $window.open('/Admin/Report/Invoice?ReportID=' + courseRegistrationID + '&ReportIDType=0',
            '_blank', 'width=1000,height=500,toolbar=no,resizable=yes,location=no,directories=no,status=no,menubar=no,copyhistory=no');
    }

    function onPrintApplicationForm(courseRegistrationID) {
        $window.open('/Admin/Report/ApplicationFormAction?CourseRegistrationID=' + courseRegistrationID,
            '_blank', 'width=1000,height=500,toolbar=no,resizable=yes,location=no,directories=no,status=no,menubar=no,copyhistory=no');
    }

    function onAttendanceUpdate(courseID, studentID) {
        attendanceDetailDialogPromise.$promise.then(function () {
            attendanceDetailDialogPromise.$scope.courseID = courseID;
            attendanceDetailDialogPromise.$scope.studentID = studentID;
            attendanceDetailDialogPromise.$scope.onAfterSuccessSave = function () {
                $scope.onActionRegistrationChanged($scope.selectedAction);
            }
            attendanceDetailDialogPromise.show();
        });
    }

    if ($scope.tenantSettings.showArrearInsteadOfPayments) {
        var column = _.find($scope.gridSettings.columns, { dataField: 'paymentsSum' });
        if (column) {
            column.dataField = 'arrear';
            column.caption = $translate.instant('TXT_LBL_ARREAR')
        }
    }
    
    $scope.selectedRegistration = {};

    $scope.onRowSelected = function (data) {
        $scope.selectedRegistration = data;
    }

    $scope.onRowEdit = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.action = $scope.selectedAction;
            detailDialogPromise.$scope.model = new webooker_courses_models.CourseRegistration(data);
            detailDialogPromise.$scope.onAfterSuccessSave = function () {
                $scope.actionRegistrations = courseRegistrationSvc.getAllForCourse($scope.selectedAction.courseID);
                $scope.onActionRegistrationChanged($scope.selectedAction);
            }
            detailDialogPromise.show();
        });
    }

    $scope.onActionRegistrationChanged = function (model) {
        $scope.$emit('onActionShouldRefresh', { action: $scope.selectedAction });
    }

    $scope.onRowAdd = function () {

        $q.all([detailDialogPromise.$promise, courseRegistrationSvc.createNew($scope.selectedAction, true)])
        .then(function (data) {
            var actionRegistration = data[1];
            detailDialogPromise.$scope.action = $scope.selectedAction;
            detailDialogPromise.$scope.model = actionRegistration;
            detailDialogPromise.$scope.onAfterSuccessSave = function () {
                $scope.actionRegistrations = courseRegistrationSvc.getAllForCourse($scope.selectedAction.courseID);
                $scope.onActionRegistrationChanged($scope.selectedAction);
            }
            detailDialogPromise.show();
        });
    }

    $scope.onRowDelete = function (data) {
        courseRegistrationSvc.remove(
            data,
            2, /* SubjectCategory.OneOffActions */
            function () {
                $scope.actionRegistrations = courseRegistrationSvc.getAllForCourse($scope.selectedAction.courseID);
                $scope.onActionRegistrationChanged($scope.selectedAction);
        });
    }

    var detailDialogPromise = $modal({
        templateUrl: 'actions/actions/actions-detail-tabs/students-detail.html',
        show: false,
        scope: $scope.$new()
    });

    var attendanceDetailDialogPromise = $modal({
        templateUrl: 'actions/actions/actions-detail-tabs/actions-attendance-detail.html',
        show: false,
        scope: $scope.$new()
    });

    var addPaymentPromise = $modal({
        templateUrl: 'finance/payments/payments-detail.html',
        show: false,
        scope: $scope.$new()
    });

    function addPayment(data) {
        addPaymentPromise.$scope.isAddDuePayment = true;
        addPaymentPromise.$scope.paymentDetail = {
            paymentID: 0,
            invoiceForType: 2,
            invoiceID: data.invoiceID,
            amount: data.arrear,
            selectedDate: moment().toDate(),
        };

        addPaymentPromise.$promise.then(function () {
            addPaymentPromise.$scope.detailError = null;
            addPaymentPromise.$scope.onSave = function () {
                $scope.actionRegistrations = courseRegistrationSvc.getAllForCourse($scope.selectedAction.courseID);
            }

            addPaymentPromise.show();
        });
    }
}]);
